// ABOUTME: Initializes reveal.js for the Mastra Guidebook v2 deck.
// ABOUTME: Injects per-chapter slide HTML before deck.initialize() so reveal sees the full slide list.

import Reveal from 'reveal.js';
import Highlight from 'reveal.js/plugin/highlight/highlight.esm.js';
import Notes from 'reveal.js/plugin/notes/notes.esm.js';

import 'reveal.js/dist/reveal.css';
import 'reveal.js/plugin/highlight/monokai.css';
import './styles/theme.css';
import './styles/components.css';

import preface from './slides/00-preface.html?raw';
import ch01 from './slides/01-what-is-mastra.html?raw';
import ch02 from './slides/02-harness-engineering.html?raw';
import ch03 from './slides/03-loop-vs-workflow.html?raw';
import ch04 from './slides/04-tools-and-integrations.html?raw';
import ch05 from './slides/05-memory-primitives.html?raw';
import ch06 from './slides/06-context-engineering.html?raw';
import ch07 from './slides/07-infrastructure-and-deployment.html?raw';
import ch08 from './slides/08-frontend-integration.html?raw';
import ch09 from './slides/09-evals-observability-guardrails.html?raw';
import ch10 from './slides/10-honest-assessment.html?raw';
import ch11 from './slides/11-in-production.html?raw';
import closing from './slides/12-closing.html?raw';

const slidesEl = document.querySelector<HTMLDivElement>('.reveal .slides');
if (!slidesEl) throw new Error('Expected .reveal .slides container');

slidesEl.innerHTML = [
  preface,
  ch01,
  ch02,
  ch03,
  ch04,
  ch05,
  ch06,
  ch07,
  ch08,
  ch09,
  ch10,
  ch11,
  closing,
].join('\n');

const deck = new Reveal({
  width: 1920,
  height: 1080,
  margin: 0,
  minScale: 0.2,
  maxScale: 2.0,
  hash: true,
  slideNumber: false,
  controls: true,
  progress: true,
  center: false,
  transition: 'slide',
  backgroundTransition: 'fade',
  pdfMaxPagesPerSlide: 1,
  pdfSeparateFragments: false,
  plugins: [Highlight, Notes],
});

deck.initialize().then(() => {
  // Expose for tooling (screenshot harness, presence check). Safe in dev/build.
  (window as unknown as { Reveal: typeof deck }).Reveal = deck;
});
